import avatar from '../assets/images/davi-marcos/davi-marcos.jpg';
import audio from '../assets/sounds/davi-marcos.mp3';

import davi01 from '../assets/images/davi-marcos/DaviMarcos_01.jpg';
import davi02 from '../assets/images/davi-marcos/DaviMarcos_02.jpg';
import davi03 from '../assets/images/davi-marcos/DaviMarcos_03.jpg';
import davi04 from '../assets/images/davi-marcos/DaviMarcos_04.jpg';
import davi05 from '../assets/images/davi-marcos/DaviMarcos_05.jpg';
import davi06 from '../assets/images/davi-marcos/DaviMarcos_06.jpg';

const daviData = {
    avatar,
    audio,
    davi01,
    davi02,
    davi03,
    davi04,
    davi05,
    davi06
}

export default daviData